import "./home.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import Widget from "../../components/widget/Widget";
import Featured from "../../components/featured/Featured";
import Chart from "../../components/chart/Chart";
import Table from "../../components/table/Table";
import { useAuth } from "../../context/AuthContext";
import { useData } from "../../context/DataContext";
import { useMemo } from "react";

const Home = () => {
  const { user } = useAuth();
  const { payments } = useData();

  // Calculate last 6 months revenue data
  const last6MonthsData = useMemo(() => {
    const monthlyData = {};
    const now = new Date();
    
    // Initialize last 6 months with 0 values
    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
      const monthName = date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
      monthlyData[monthKey] = { name: monthName, Total: 0 };
    }

    // Sum payments by month
    payments.forEach(payment => {
      if (payment.paymentDate && payment.status === 'Paid') {
        let date;
        
        // Handle different date formats
        if (typeof payment.paymentDate === 'object' && payment.paymentDate.seconds) {
          // Firestore Timestamp
          date = new Date(payment.paymentDate.seconds * 1000);
        } else if (payment.paymentDate instanceof Date) {
          // Date object
          date = payment.paymentDate;
        } else {
          // String date
          date = new Date(payment.paymentDate);
        }
        
        // Check if date is valid
        if (!isNaN(date.getTime())) {
          const monthKey = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`;
          
          if (monthlyData[monthKey]) {
            monthlyData[monthKey].Total += payment.amount || 0;
          }
        }
      }
    });

    return Object.values(monthlyData);
  }, [payments]);

  return (
    <div className="home">
      <Sidebar />
      <div className="homeContainer">
        <Navbar />
        <div className="widgets">
          <Widget type="user" />
          <Widget type="order" />
          <Widget type="earning" />
          <Widget type="balance" />
        </div>
        <div className="charts">
          <Featured />
          <Chart title="Last 6 Months (Revenue)" aspect={2 / 1} data={last6MonthsData} />
        </div>
        <div className="listContainer">
          <div className="listTitle">
            {user?.role === 'tenant' ? 'Recent Transactions & Requests' : 'Latest Transactions'}
          </div>
          <Table />
        </div>
      </div>
    </div>
  );
};

export default Home;
